<template>
  <f7-page id="reg-biometry-success" name="reg-biometry-success" class="mb-xxl" @page:afterin="afterin">
    <div class="content text-align-center">
      <img :src="require('@/assets/img/icon/icon-success.svg')"/>
      <div class="wandr-title-1 text-align-center mt-lg" v-html="titleText"></div>
    </div>

    <f7-toolbar position="bottom" no-hairline class="toolbar-with-button">
      <f7-button large fill @click="goToHomePage">
          {{$t('general-text-continue')}}
      </f7-button>
    </f7-toolbar>
  </f7-page>
</template>

<script>
  export default {
    mounted (){
      const typeOfBiometry = this.biometryType == 1 ? this.$t('general-text-finger-print-id') : (this.biometryType == 2 ? this.$t('general-text-face-id') : "")
      
      this.titleText = this.$t('regis-biometry-enabled', {biometrytype: typeOfBiometry})
    },
    props: {
      biometryType: Number
    },
    data() {
      return {
        titleText           : "",
      };
    },
    methods: {
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      goToHomePage() {
        this.showPreloader();
        this.$f7router.navigate("/home");
        this.hidePreloader();
      }
    },
    components: {

    },
    computed: {

    },
  }
</script>